import { useEffect } from "react";

import GlobalStyle from "./styled/GlobalStyle";
import Hero from "./components/Hero";
import Header from "./components/Header";
import Gallery from "./components/Gallery";
import Footer from "./components/Footer";
import Info from "./components/Info";
import WhatsApp from "./components/Whatsapp";
import Surdurulebilirlik from "./components/Surdurelebilirlik";
import EngelliOdasi from "./components/engelliodasi";

const App = () => {
  // QR kodla gelindiğinde otomatik scroll yapan çözüm
  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 300); // Mobilde render beklemek için gecikme
    }
  }, []);

  return (
    <main>
      <GlobalStyle />
      <Header />
      <Hero />
      <Info />
      <Gallery />
      <EngelliOdasi />
      <Surdurulebilirlik />
      <WhatsApp />
      <Footer />
    </main>
  );
};

export default App;
